import { formatApiError } from '@/api/errors'

/**
 * Título e mensagem da falha ao salvar um secret na tela de Recursos.
 *
 * 409 = o valor deste secret está no Terraform do projeto (`ignore_secret_changes
 * = false`): o próximo apply desfaria a edição, e o backend recusa com
 * `detail.motivo` (spec 2026-10-08 D18). O motivo vai inteiro, porque é ele que
 * diz o que fazer (pedir pelo chamado).
 */
export function erroAoSalvarSecret(err: unknown): { title: string; message: string } {
  const e = err as { response?: { status?: number; data?: { detail?: unknown } } } | null
  const detail = e?.response?.data?.detail
  if (e?.response?.status === 409 && detail && typeof detail === 'object') {
    const motivo = (detail as { motivo?: unknown }).motivo
    if (typeof motivo === 'string' && motivo) {
      return { title: 'Secret controlado pelo Terraform', message: motivo }
    }
  }
  const texto = formatApiError(err, 'Erro desconhecido')
  return {
    title: 'Erro ao salvar',
    message: e?.response?.status === 403 || texto.includes('403') || texto.includes('PermissionError')
      ? 'Sem permissão para editar secrets neste tenant.'
      : `Falha ao atualizar secret: ${texto}`,
  }
}
